import React from 'react'
import { child_icon_3 } from '../../../icons'
import './ItemCountPill.css'

function ItemCountPill(props) {

    const badgeCss = !props.short ? "item-count-badge" : "item-count-badge-short";

    return (
        <span className={`badge rounded-pill data-badge-red ${badgeCss}`}>
            <i className="bi bi-cart"></i>
            {props.short ?
                <>
                    {props.itemCount}
                </>
                :
                <>
                    <span className='ms-1'>{props.itemCount} Items</span>
                </>
            }
        </span>
    )
}

export default ItemCountPill